export enum WritingActionType {
  MoveTo = 'MoveTo',
  LineTo = 'LineTo',
}

export enum WritingRecognitionType {
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
  REVERSE = 'reverse',
  UNKNOWN = 'unknown',
  NOT_FOUND = 'not_found',
}

export interface ViewBox {
  minX: number;
  minY: number;
  width: number;
  height: number;
}

export interface Coordinates {
  x: number;
  y: number;
}

export interface WritingAction extends Coordinates {
  type: WritingActionType;
}
